/* =========================================================
   RAFIA – CUSTOM COLLECTION
   Filtering, sorting, load more, grid layout, filter drawer,
   wishlist, add to bag and quick view.
   Everything uses event delegation, so it keeps working on
   products loaded after filtering or "Load more".
========================================================= */
(function () {
  'use strict';

  if (window.__ccCollectionLoaded) return;
  window.__ccCollectionLoaded = true;

  /* ---------- Helpers ---------- */
  var store = {
    get: function (key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } },
    set: function (key, value) { try { window.localStorage.setItem(key, value); } catch (e) {} }
  };

  var mqMobile = window.matchMedia('(max-width: 768px)');
  var mqFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.classList.toggle('cc-scroll-lock', scrollLocks > 0);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* =========================================================
     WISHLIST (saved on this device, works on every page)
  ========================================================= */
  var WL_KEY = 'wishlist';

  function getWishlist() {
    try {
      var list = JSON.parse(store.get(WL_KEY));
      return Array.isArray(list) ? list.map(String) : [];
    } catch (e) { return []; }
  }

  function paintWishlist(scope) {
    var list = getWishlist();
    (scope || document).querySelectorAll('[data-cc-wishlist]').forEach(function (btn) {
      var on = list.indexOf(String(btn.dataset.ccWishlist)) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-wishlist]');
    if (!btn) return;
    e.preventDefault();

    var id = String(btn.dataset.ccWishlist);
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx > -1) list.splice(idx, 1); else list.push(id);
    store.set(WL_KEY, JSON.stringify(list));

    paintWishlist();
    btn.classList.remove('is-popping');
    void btn.offsetWidth;
    btn.classList.add('is-popping');

    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { ids: list } }));
  });

  /* Keep hearts in sync if the wishlist changes in another tab or in quick view */
  window.addEventListener('storage', function (e) {
    if (e.key === WL_KEY) paintWishlist();
  });
  document.addEventListener('wishlist:change', function () { paintWishlist(); });

  /* =========================================================
     CARD MESSAGES + SIZE PICKER
  ========================================================= */
  function showCardMessage(card, text, isError) {
    var box = card && card.querySelector('.cc-card-msg');
    if (!box) return;
    box.textContent = text;
    box.classList.toggle('is-error', !!isError);
    box.classList.add('is-visible');
    clearTimeout(box._timer);
    box._timer = setTimeout(function () { box.classList.remove('is-visible'); }, 2600);
  }

  function closePicker(card) {
    if (!card || !card.classList.contains('picker-open')) return;
    card.classList.remove('picker-open');
    var picker = card.querySelector('[data-cc-picker]');
    var trigger = card.querySelector('[data-cc-open-picker]');
    if (picker) picker.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openPicker(card) {
    document.querySelectorAll('.cc-card.picker-open').forEach(function (c) { if (c !== card) closePicker(c); });
    var picker = card.querySelector('[data-cc-picker]');
    var trigger = card.querySelector('[data-cc-open-picker]');
    if (!picker) return;
    card.classList.add('picker-open');
    picker.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var first = picker.querySelector('.cc-picker-opt:not([disabled])');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cc-open-picker]');
    if (openBtn) {
      e.preventDefault();
      var card = openBtn.closest('[data-cc-card]');
      if (card.classList.contains('picker-open')) closePicker(card); else openPicker(card);
      return;
    }
    var closeBtn = e.target.closest('[data-cc-picker-close]');
    if (closeBtn) {
      closePicker(closeBtn.closest('[data-cc-card]'));
      return;
    }
    /* Click outside closes any open picker */
    if (!e.target.closest('[data-cc-picker]')) {
      document.querySelectorAll('.cc-card.picker-open').forEach(closePicker);
    }
  });

  /* =========================================================
     ADD TO BAG (opens the theme's cart drawer)
  ========================================================= */
  function updateCartCount() {
    fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-count')
          .forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn) {
    var card = btn.closest('[data-cc-card]');
    if (btn.classList.contains('is-loading')) return;

    var drawer = document.querySelector('cart-drawer');
    var notification = drawer ? null : document.querySelector('cart-notification');
    var target = drawer || notification;

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    var canRender = target && typeof target.getSectionsToRender === 'function' && typeof target.renderContents === 'function';
    if (canRender) {
      body.append('sections', target.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      if (typeof target.setActiveElement === 'function') target.setActiveElement(btn);
    }

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          showCardMessage(card, res.description || res.message || 'Could not add to bag', true);
          return;
        }

        closePicker(card);

        if (canRender) {
          target.renderContents(res);
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        } else {
          updateCartCount();
          showCardMessage(card, 'Added to bag');
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cc-collection', productVariantId: variantId, cartData: res });
        }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: res }));
      })
      .catch(function () {
        showCardMessage(card, 'Something went wrong. Please try again.', true);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-add]');
    if (!btn || btn.disabled || !btn.closest('[data-cc-card]')) return;
    e.preventDefault();
    addToCart(btn.dataset.ccAdd, btn);
  });

  /* =========================================================
     QUICK VIEW (one modal for the whole page)
  ========================================================= */
  var qvCache = {};
  var qvRequest = 0;
  var qvLastFocus = null;

  function getModal() {
    var modal = document.querySelector('[data-cc-qv]');
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    return modal;
  }

  function closeQuickView() {
    var modal = document.querySelector('[data-cc-qv].is-open');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    qvRequest++;
    var content = modal.querySelector('[data-cc-qv-content]');
    setTimeout(function () { if (!modal.classList.contains('is-open')) content.innerHTML = ''; }, 350);
    if (qvLastFocus) qvLastFocus.focus({ preventScroll: true });
  }

  /* Scripts inside injected HTML don't run on their own, so re-create them */
  function runScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }

  function buildQuickViewHTML(html) {
    var doc = parseHTML(html);
    var productSection = doc.querySelector('.custom-product-v2');
    if (!productSection) return null;

    var wrapper = document.createElement('div');
    doc.querySelectorAll('style').forEach(function (style) {
      var css = style.textContent || '';
      if (css.indexOf('.custom-product-v2') > -1 || css.indexOf('.size-chart-modal') > -1 || css.indexOf('.lightbox-modal') > -1) {
        wrapper.appendChild(style.cloneNode(true));
      }
    });
    wrapper.appendChild(productSection.cloneNode(true));
    /* Older product sections kept these modals outside the section */
    doc.querySelectorAll('.size-chart-modal, .lightbox-modal').forEach(function (node) {
      if (!productSection.contains(node)) wrapper.appendChild(node.cloneNode(true));
    });
    return wrapper.innerHTML;
  }

  function openQuickView(url, trigger) {
    var modal = getModal();
    if (!modal) { window.location.href = url; return; }
    var content = modal.querySelector('[data-cc-qv-content]');
    var id = ++qvRequest;

    qvLastFocus = trigger || document.activeElement;
    if (!modal.classList.contains('is-open')) lockScroll(true);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal.querySelector('.cc-quick-view-modal__close').focus({ preventScroll: true });

    function inject(markup) {
      content.innerHTML = markup;
      runScripts(content);
      content.scrollTop = 0;
    }

    if (qvCache[url]) { inject(qvCache[url]); return; }

    content.innerHTML = '<div class="cc-quick-view-modal__loading"><span class="cc-spinner"></span></div>';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.text(); })
      .then(function (html) {
        if (id !== qvRequest) return;
        var markup = buildQuickViewHTML(html);
        if (!markup) throw new Error('missing');
        qvCache[url] = markup;
        inject(markup);
      })
      .catch(function () {
        if (id !== qvRequest) return;
        content.innerHTML = '<div class="cc-quick-view-modal__error"><p>Quick view couldn\'t load.</p><a href="' + url + '">Open the product page</a></div>';
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cc-quick-view]');
    if (trigger) {
      e.preventDefault();
      openQuickView(trigger.dataset.ccQuickView, trigger);
      return;
    }
    if (e.target.closest('[data-cc-qv-close]')) closeQuickView();
  });

  /* Close quick view once something is added to the cart (the cart drawer takes over) */
  function watchCart() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { closeQuickView(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.querySelector('.lightbox-modal.is-open, .size-chart-modal.is-open')) return;
    closeQuickView();
    document.querySelectorAll('.cc-card.picker-open').forEach(closePicker);
  });

  /* =========================================================
     COLLECTION PAGE (one instance per section)
  ========================================================= */
  function initCollection(root) {
    if (!root || root.dataset.ccReady) return;
    root.dataset.ccReady = '1';

    var sectionId = root.dataset.sectionId;
    var form = root.querySelector('[data-cc-form]');
    var sidebar = root.querySelector('[data-cc-sidebar]');
    var overlay = root.querySelector('.cc-drawer-overlay');
    var openFilterBtn = root.querySelector('[data-cc-open-filters]');
    var toolbar = root.querySelector('[data-cc-toolbar]');

    paintWishlist(root);

    /* ---------------- Grid layout (saved per device) ---------------- */
    function currentDevice() { return mqMobile.matches ? 'mobile' : 'desktop'; }

    function defaultCols() {
      if (mqMobile.matches) return 2;
      var d = parseInt(root.dataset.desktopCols, 10) || 4;
      return window.innerWidth <= 1200 ? Math.min(3, d) : d;
    }

    function applyGrid() {
      var device = currentDevice();
      var saved = parseInt(store.get('cc-grid-' + device), 10);
      var cols = saved || defaultCols();
      var grid = root.querySelector('[data-cc-grid]');
      if (grid) {
        grid.style.setProperty('--cc-cols', cols);
        grid.dataset.cols = cols;
      }
      root.querySelectorAll('.cc-view-btn[data-grid]').forEach(function (b) {
        var on = b.dataset.device === device && parseInt(b.dataset.grid, 10) === cols;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('.cc-view-btn[data-grid]');
      if (!b) return;
      store.set('cc-grid-' + b.dataset.device, b.dataset.grid);
      applyGrid();
    });

    if (mqMobile.addEventListener) mqMobile.addEventListener('change', applyGrid);
    window.addEventListener('resize', debounce(applyGrid, 150));
    applyGrid();

    /* ---------------- Filter drawer ---------------- */
    var lastFocus = null;
    if (sidebar) sidebar.inert = true;

    function openDrawer() {
      if (!sidebar || sidebar.classList.contains('active')) return;
      lastFocus = document.activeElement;
      refreshFilters();
      sidebar.inert = false;
      sidebar.classList.add('active');
      if (overlay) overlay.classList.add('active');
      sidebar.setAttribute('aria-hidden', 'false');
      if (openFilterBtn) openFilterBtn.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      setTimeout(function () { sidebar.focus({ preventScroll: true }); }, 50);
    }

    function closeDrawer() {
      if (!sidebar || !sidebar.classList.contains('active')) return;
      sidebar.classList.remove('active');
      sidebar.inert = true;
      if (overlay) overlay.classList.remove('active');
      sidebar.setAttribute('aria-hidden', 'true');
      if (openFilterBtn) openFilterBtn.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-open-filters]')) { openDrawer(); return; }
      if (e.target.closest('[data-cc-close-filters]')) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); closeSort(); }
    });

    /* ---------------- Accordions (open state survives updates) ---------------- */
    function openAccordions() {
      var open = {};
      root.querySelectorAll('.cc-accordion').forEach(function (a) {
        open[a.dataset.ccAcc] = a.classList.contains('active');
      });
      return open;
    }

    function restoreAccordions(state) {
      root.querySelectorAll('.cc-accordion').forEach(function (a) {
        if (!(a.dataset.ccAcc in state)) return;
        var on = state[a.dataset.ccAcc];
        a.classList.toggle('active', on);
        var btn = a.querySelector('.cc-accordion-btn');
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.cc-accordion-btn');
      if (!btn) return;
      var acc = btn.closest('.cc-accordion');
      var on = acc.classList.toggle('active');
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    /* ---------------- Price slider ---------------- */
    function setupPrice() {
      root.querySelectorAll('[data-cc-price]').forEach(function (box) {
        var max = parseFloat(box.dataset.max) || 0;
        var rMin = box.querySelector('[data-cc-range="min"]');
        var rMax = box.querySelector('[data-cc-range="max"]');
        var nMin = box.querySelector('[data-cc-num="min"]');
        var nMax = box.querySelector('[data-cc-num="max"]');
        var fill = box.querySelector('[data-cc-fill]');
        if (!rMin || !rMax || !max) return;

        function paint() {
          var a = Math.min(+rMin.value, +rMax.value);
          var b = Math.max(+rMin.value, +rMax.value);
          fill.style.left = (a / max * 100) + '%';
          fill.style.right = (100 - b / max * 100) + '%';
        }

        function fromRange(e) {
          var a = +rMin.value, b = +rMax.value;
          if (a > b) { if (e.target === rMin) rMin.value = b; else rMax.value = a; }
          nMin.value = +rMin.value > 0 ? rMin.value : '';
          nMax.value = +rMax.value < max ? rMax.value : '';
          paint();
        }

        function fromNumbers() {
          rMin.value = nMin.value === '' ? 0 : Math.max(0, Math.min(max, +nMin.value));
          rMax.value = nMax.value === '' ? max : Math.max(0, Math.min(max, +nMax.value));
          paint();
        }

        rMin.addEventListener('input', fromRange);
        rMax.addEventListener('input', fromRange);
        nMin.addEventListener('input', fromNumbers);
        nMax.addEventListener('input', fromNumbers);
        paint();
      });
    }
    setupPrice();

    /* ---------------- Sort dropdown ---------------- */
    var sortWrap = root.querySelector('[data-cc-sort]');
    var sortBtn = root.querySelector('[data-cc-sort-btn]');
    var sortList = root.querySelector('[data-cc-sort-list]');
    var sortSelect = root.querySelector('[data-cc-sort-select]');
    var sortCurrent = root.querySelector('[data-cc-sort-current]');

    function openSort() {
      if (!sortWrap) return;
      sortWrap.classList.add('is-open');
      sortBtn.setAttribute('aria-expanded', 'true');
      var sel = sortList.querySelector('[aria-selected="true"]') || sortList.firstElementChild;
      if (sel) sel.focus({ preventScroll: true });
    }

    function closeSort() {
      if (!sortWrap || !sortWrap.classList.contains('is-open')) return;
      sortWrap.classList.remove('is-open');
      sortBtn.setAttribute('aria-expanded', 'false');
    }

    function pickSort(li) {
      sortSelect.value = li.dataset.value;
      sortList.querySelectorAll('[role="option"]').forEach(function (o) {
        o.setAttribute('aria-selected', o === li ? 'true' : 'false');
      });
      if (sortCurrent) sortCurrent.textContent = li.textContent.trim();
      closeSort();
      sortBtn.focus({ preventScroll: true });
      sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (sortWrap) {
      sortBtn.tabIndex = mqFinePointer.matches ? 0 : -1;
      sortSelect.tabIndex = mqFinePointer.matches ? -1 : 0;

      sortBtn.addEventListener('click', function () {
        if (sortWrap.classList.contains('is-open')) closeSort(); else openSort();
      });
      sortList.addEventListener('click', function (e) {
        var li = e.target.closest('[role="option"]');
        if (li) pickSort(li);
      });
      sortList.addEventListener('keydown', function (e) {
        var items = Array.prototype.slice.call(sortList.querySelectorAll('[role="option"]'));
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
        if ((e.key === 'Enter' || e.key === ' ') && i > -1) { e.preventDefault(); pickSort(items[i]); }
        if (e.key === 'Tab') closeSort();
      });
      document.addEventListener('click', function (e) {
        if (!sortWrap.contains(e.target)) closeSort();
      });
      /* Native select (touch devices) keeps the label in sync */
      sortSelect.addEventListener('change', function () {
        var opt = sortSelect.options[sortSelect.selectedIndex];
        if (sortCurrent && opt) sortCurrent.textContent = opt.text.trim();
        sortList.querySelectorAll('[role="option"]').forEach(function (o) {
          o.setAttribute('aria-selected', o.dataset.value === sortSelect.value ? 'true' : 'false');
        });
      });
    }

    /* ---------------- Fetching results ---------------- */
    var controller = null;

    function setLoading(on) {
      root.classList.toggle('is-loading', on);
    }

    function formQuery() {
      if (!form) return '';
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      return params.toString();
    }

    function sectionURL(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }

    function scrollToTop() {
      if (sidebar && sidebar.classList.contains('active')) return;
      var rect = toolbar.getBoundingClientRect();
      if (rect.top < 0) {
        window.scrollTo({ top: window.scrollY + rect.top - 100, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }

    /* Filter panel only: options, counts, footer, badge */
    function swapFilters(doc, accState) {
      accState = accState || openAccordions();
      var freshForm = doc.querySelector('[data-cc-form]');
      if (freshForm && form) form.innerHTML = freshForm.innerHTML;

      var freshFoot = doc.querySelector('[data-cc-foot]');
      var foot = root.querySelector('[data-cc-foot]');
      if (freshFoot && foot) foot.innerHTML = freshFoot.innerHTML;

      var freshBadge = doc.querySelector('[data-cc-badge]');
      var badge = root.querySelector('[data-cc-badge]');
      if (freshBadge && badge) {
        badge.textContent = freshBadge.textContent;
        badge.hidden = freshBadge.hasAttribute('hidden');
      }

      restoreAccordions(accState);
      setupPrice();
      filtersFresh = true;
    }

    /* Shopify can serve the first page with cached filter counts (e.g. "In stock 0").
       Results loaded by AJAX are always live, so refresh the counts once when the drawer opens. */
    var filtersFresh = false;
    var filterRequest = 0;
    function refreshFilters() {
      if (filtersFresh || !form) return;
      filtersFresh = true;
      var mine = ++filterRequest;
      var url = window.location.pathname + window.location.search;
      fetch(sectionURL(url), { cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('load'); return r.text(); })
        .then(function (html) {
          /* If the customer already ticked something, that newer result wins */
          if (mine === filterRequest) swapFilters(parseHTML(html));
        })
        .catch(function () { filtersFresh = false; });
    }

    function swap(doc) {
      var accState = openAccordions();
      var focused = document.activeElement;
      var focusName = focused && form && form.contains(focused) ? focused.name : null;
      var focusValue = focusName && focused.type === 'checkbox' ? focused.value : null;

      ['[data-cc-results]', '[data-cc-active]', '[data-cc-foot]', '[data-cc-count]'].forEach(function (sel) {
        var fresh = doc.querySelector(sel);
        var current = root.querySelector(sel);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });

      swapFilters(doc, accState);
      applyGrid();
      paintWishlist(root);

      root.querySelectorAll('[data-cc-grid] > *').forEach(function (card, i) {
        card.style.animationDelay = Math.min(i, 12) * 30 + 'ms';
        card.classList.add('cc-fade-in');
      });

      if (focusName) {
        var again = Array.prototype.find.call(form.elements, function (el) {
          return el.name === focusName && (focusValue === null || el.value === focusValue);
        });
        if (again) again.focus({ preventScroll: true });
      }

      observeLoadMore();
    }

    /* =========================================================
       SOLD OUT LAST
       In-stock products are loaded first (filter.v.availability=1),
       then sold-out ones (=0), without changing the URL or filters.
    ========================================================= */
    var AV = 'filter.v.availability';
    var stream = null; /* { phase: 'in' | 'out', base, next, total, perPage } */
    var streamRun = 0;  /* a newer filter/sort cancels an older in-stock load */

    function hasAv(url) {
      return new URL(url, window.location.origin).searchParams.has(AV);
    }

    function streamApplies(url) {
      return root.dataset.soldOutLast === 'true' && !hasAv(url);
    }

    function withAv(url, value) {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete(AV);
      u.searchParams.delete('page');
      u.searchParams.set(AV, value);
      return u.pathname + u.search;
    }

    function fetchDoc(url) {
      return fetch(sectionURL(url))
        .then(function (r) { if (!r.ok) throw new Error('load'); return r.text(); })
        .then(parseHTML);
    }

    function cardsOf(doc) {
      var g = doc.querySelector('[data-cc-grid]');
      return g ? Array.prototype.slice.call(g.children) : [];
    }

    function nextOf(doc) {
      var a = doc.querySelector('[data-cc-load-more]');
      return a ? a.getAttribute('href') : null;
    }

    function animateCards(cards) {
      cards.forEach(function (card, i) {
        card.style.animationDelay = Math.min(i, 12) * 30 + 'ms';
        card.classList.add('cc-fade-in');
      });
    }

    function syncPagination() {
      var results = root.querySelector('[data-cc-results]');
      var old = results && results.querySelector('[data-cc-pagination]');
      if (old) old.remove();
      var grid = root.querySelector('[data-cc-grid]');
      if (!grid || !stream) return;

      var shown = grid.children.length;
      var total = Math.max(stream.total, shown);
      if (shown >= total) stream.next = null; /* everything is on the page */
      if (!stream.next && shown <= stream.perPage) return;

      var pct = total ? Math.round(shown * 100 / total) : 100;
      var box = document.createElement('div');
      box.className = 'cc-pagination';
      box.setAttribute('data-cc-pagination', '');
      box.innerHTML =
        '<p class="cc-pagination-text">Showing ' + shown + ' of ' + total + ' products</p>' +
        '<div class="cc-pagination-bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
      if (stream.next) {
        var a = document.createElement('a');
        a.className = 'cc-load-more';
        a.setAttribute('data-cc-load-more', '');
        a.href = stream.next;
        a.innerHTML = '<span>Load more</span>';
        box.appendChild(a);
      }
      grid.parentNode.insertBefore(box, grid.nextSibling);
    }

    /* Replace the results with in-stock products first. Resolves false if it can't. */
    function startStream(baseUrl) {
      var run = ++streamRun;
      var meta = root.querySelector('[data-cc-meta]');
      var total = meta ? parseInt(meta.getAttribute('data-total'), 10) || 0 : 0;
      if (!total) { stream = null; return Promise.resolve(false); }

      return fetchDoc(withAv(baseUrl, '1')).then(function (inDoc) {
        /* Availability filter switched off in Search & Discovery: keep normal order */
        if (!inDoc.querySelector('[data-cc-av]')) { stream = null; return false; }

        var s = { phase: 'in', base: baseUrl, total: total, perPage: parseInt(root.dataset.perPage, 10) || 24 };
        var inCards = cardsOf(inDoc);
        s.next = nextOf(inDoc);

        if (inCards.length) {
          if (!s.next) { s.phase = 'out'; s.next = withAv(baseUrl, '0'); }
          return { s: s, doc: inDoc };
        }
        /* Nothing in stock: start straight with sold-out products */
        return fetchDoc(withAv(baseUrl, '0')).then(function (outDoc) {
          s.phase = 'out';
          s.next = nextOf(outDoc);
          return { s: s, doc: outDoc };
        });
      }).then(function (res) {
        if (!res || run !== streamRun) return false;
        var results = root.querySelector('[data-cc-results]');
        var fresh = res.doc.querySelector('[data-cc-results]');
        var freshGrid = res.doc.querySelector('[data-cc-grid]');
        if (!results || !fresh || !freshGrid) { stream = null; return false; }

        /* Keep this page's total, use the in-stock product list */
        var meta = results.querySelector('[data-cc-meta]');
        results.innerHTML = fresh.innerHTML;
        var newMeta = results.querySelector('[data-cc-meta]');
        if (meta && newMeta) newMeta.replaceWith(meta);

        stream = res.s;
        syncPagination();
        applyGrid();
        paintWishlist(root);
        observeLoadMore();
        return true;
      }).catch(function () { stream = null; return false; });
    }

    function render(url, push) {
      filterRequest++;
      streamRun++;
      if (controller) controller.abort();
      var mine = controller = new AbortController();
      setLoading(true);

      return fetch(sectionURL(url), { signal: mine.signal })
        .then(function (r) { if (!r.ok) throw new Error('load'); return r.text(); })
        .then(function (html) {
          stream = null;
          swap(parseHTML(html));
          if (push !== false) history.pushState({ cc: sectionId }, '', url);
          scrollToTop();
          if (streamApplies(url) && controller === mine) return startStream(url);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          window.location.href = url; /* fall back to a normal page load */
        })
        .finally(function () {
          if (controller === mine) setLoading(false);
        });
    }

    function applyForm() {
      var q = formQuery();
      render(window.location.pathname + (q ? '?' + q : ''));
    }

    var applyFormSoon = debounce(applyForm, 700);

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); applyForm(); });

      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.type === 'checkbox' || t.type === 'range' || t.type === 'number') applyForm();
      });

      form.addEventListener('input', function (e) {
        if (e.target.type === 'number') applyFormSoon();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', applyForm);
    }

    /* Chips, "Clear all", empty-state buttons */
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-cc-link]');
      if (!link || !link.href) return;
      e.preventDefault();
      render(link.getAttribute('href'));
    });

    /* Back / forward buttons */
    history.replaceState({ cc: sectionId }, '');
    window.addEventListener('popstate', function () {
      render(window.location.pathname + window.location.search, false);
    });

    /* ---------------- Load more ---------------- */
    var loadingMore = false;
    var infiniteObserver = null;

    function loadMore(link) {
      if (loadingMore || !link) return;
      loadingMore = true;
      link.classList.add('is-loading');

      fetch(sectionURL(link.href))
        .then(function (r) { if (!r.ok) throw new Error('load'); return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var grid = root.querySelector('[data-cc-grid]');
          var fresh = cardsOf(doc);

          if (grid) {
            /* Never show the same product twice */
            var seen = {};
            Array.prototype.forEach.call(grid.children, function (c) { seen[c.dataset.productId] = true; });
            var added = fresh.filter(function (c) { return !seen[c.dataset.productId]; });
            animateCards(added);
            added.forEach(function (c) { grid.appendChild(c); });
          }

          if (stream) {
            stream.next = nextOf(doc);
            if (!stream.next && stream.phase === 'in') {
              stream.phase = 'out';
              stream.next = withAv(stream.base, '0');
            }
            syncPagination();
          } else {
            var pag = root.querySelector('[data-cc-pagination]');
            var freshPag = doc.querySelector('[data-cc-pagination]');
            if (pag) { if (freshPag) pag.replaceWith(freshPag); else pag.remove(); }
          }
          paintWishlist(root);
          applyGrid();
        })
        .catch(function () { window.location.href = link.href; })
        .finally(function () {
          loadingMore = false;
          observeLoadMore();
        });
    }

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-cc-load-more]');
      if (!link) return;
      e.preventDefault();
      loadMore(link);
    });

    function observeLoadMore() {
      if (root.dataset.infinite !== 'true' || !('IntersectionObserver' in window)) return;
      if (infiniteObserver) infiniteObserver.disconnect();
      var link = root.querySelector('[data-cc-load-more]');
      if (!link) return;
      infiniteObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadMore(link);
      }, { rootMargin: '600px 0px' });
      infiniteObserver.observe(link);
    }
    observeLoadMore();

    if (root.classList.contains('cc-stream-pending')) {
      startStream(window.location.pathname + window.location.search).then(function () {
        root.classList.remove('cc-stream-pending');
      });
    }
  }

  /* =========================================================
     START
  ========================================================= */
  function start() {
    document.querySelectorAll('[data-cc-root]').forEach(initCollection);
    paintWishlist();
    getModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cc-root]');
    if (root) initCollection(root);
  });
})();
